<template>
<v-card elevation="0" class="rounded-lr-xxl">
    <v-card-text elevation="0" class="mt-2">
    <v-layout row wrap>
        <v-flex xs12 class="pa-2">
            <DatePicker v-if="!loading.fetchData" v-model="item.wti_date_start" label="Réalisé le" :objectForm="item" fieldName='wti_date_start'></DatePicker>
        </v-flex>

        <v-flex xs6 class="pa-2">
            <AutocompleteMulti 
                        :title="'Agent'" :ressource="'users'"
                        :listObject.sync="item.wti_usr_id" :listParent="userList" 
                        :fields="{
                            index: 'id', text:'firstName,lastName', autofocus: true,
                            search:'middleName', preprendIcon:'mdi-account-group', multiSelect:false, prefetch: false, resultlimit:'25', params:'' 
                    }"></AutocompleteMulti>
        </v-flex>
        <v-flex xs6 class="pa-2">
        <AutocompleteMulti 
                :title="'Materiel'" :ressource="'equipments'"
                :listObject.sync="item.wti_equ_id" :listParent="equipmentList" 
                :fields="{ 
                    index: 'equ_id', text:'equ_name', autofocus: true, deletablechips: true,
                    search:'equ_name', preprendIcon:'mdi-tools', multiSelect:false, prefetch: true, params:'' 
            }"></AutocompleteMulti>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-select v-show="(!item.wti_equ_id)" prepend-icon="mdi-timetable" :items="this.typeListByGroup['WTI']" item-text="typ_name" item-value="typ_id" :outlined="true"
                v-model="item.wti_typ_id" label="Statut" single-line >   
            </v-select>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-text-field ref="wtiDuration" outlined dense class="rounded-lg" prepend-icon="mdi-clock-time-two-outline" 
                :label="(item.wti_equ_id) ? 'Temps materiel' : 'Temps de travail matin'" 
                v-model="item.wti_duration_am" type="time" >
            </v-text-field>
            <v-text-field ref="wtiDuration" outlined dense class="rounded-lg" prepend-icon="mdi-clock-time-two-outline" 
                :label="(item.wti_equ_id) ? 'Temps materiel' : 'Temps de travail après midi'" 
                v-model="item.wti_duration_pm" type="time" >
            </v-text-field>
        </v-flex>
        <v-flex xs12 class="pa-2">
            <v-alert border="left" colored-border color="deep-purple accent-4" elevation="2" >
                Si un matériel est selectionné, le temps compte pour du temps matériel
                <v-chip label outlined v-show="item.wti_created_at" class="d-flex flex-column">
                Création : 
                {{ (item.wti_created_at) ? $date(item.wti_created_at).format('DD/MM/YYYY') : '' }}
            </v-chip>
            </v-alert>
        </v-flex>
    </v-layout>
    </v-card-text>
    <v-divider light></v-divider>
    <v-card-actions>
        <v-menu v-if="(!item.wti_validated) && (item.wti_id_am > 0 || item.wti_id_pm > 0)" v-model="optionMenu" offset-y transition="slide-x-transition" bottom right >
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" outlined class="ml-0 pa-0" style="min-width: 5px;" color="grey"><v-icon>mdi-dots-vertical</v-icon></v-btn>
            </template>
            <v-btn class="ma-0" color="error" @click.native="deleteWorktime()" :disabled="saveProgress">
                <v-icon left>mdi-trash-can</v-icon>Supprimer
            </v-btn>
        </v-menu>
        <v-spacer></v-spacer>
        <v-btn rounded v-if="(!item.wti_validated )"
            color="success" 
            :loading="saveProgress" @click.native="saveWorktime()" :disabled="!validForm">
            Enregistrer
        </v-btn>
        <v-btn rounded outlined color="grey" @click="switchModal('modalWorktime', 0)">
            Fermer
        </v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import DatePicker from '@/components/ui/DatePicker'
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'

import { mapState } from 'pinia'
import { useTypeStore } from '@/stores/type'
import { useUserStore } from '@/stores/user'
import { useEquipmentStore } from '@/stores/equipment'

export default {
    name: 'worktime-edit',
    components: { DatePicker, AutocompleteMulti },
    props: ['switchModal', 'groupItem', 'eve_id'],
    //mixins: [ wtiObj ],
    computed: {
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useUserStore, {userList: 'itemList', user: 'me' }),
        ...mapState(useEquipmentStore, {equipmentList: 'itemList' }),
        validForm(){
            return (this.item.wti_usr_id && (this.item.wti_duration_am !== '00:00' || this.item.wti_duration_pm !== '00:00'))
        },
    }, 
    data: function () {
        return {
            loading : { fetchData: true },
            saveProgress: false,         // Enregistrement en cours...
            optionMenu: false,
            item: {},
        }
    },
    async mounted (){
        // Le formulaire édite une ligne "groupée" (1 ligne affichée = jusqu'à 2 lignes f_worktime AM/PM)
        if( this.groupItem && (this.groupItem.wti_id_am > 0 || this.groupItem.wti_id_pm > 0) ){
            this.item = { ...this.groupItem }
        } else {
            this.item = {
                wti_id         : 0,
                wti_id_am      : 0,
                wti_id_pm      : 0,
                wti_eve_id     : this.eve_id,
                wti_usr_id     : (this.groupItem && this.groupItem.wti_usr_id) ? this.groupItem.wti_usr_id : this.user.id,
                wti_equ_id     : (this.groupItem && this.groupItem.wti_equ_id) ? this.groupItem.wti_equ_id : null,
                wti_typ_id     : 'WTI01',
                wti_date_start : this.$date().format('YYYY-MM-DD'),
                wti_duration_am: (this.groupItem && this.groupItem.wti_duration_am) ? this.groupItem.wti_duration_am : '00:00',
                wti_duration_pm: (this.groupItem && this.groupItem.wti_duration_pm) ? this.groupItem.wti_duration_pm : '00:00',
                wti_validated  : 0,
                wti_created_at : null
            }
            setTimeout( () => { if( this.$refs['wtiDuration'] ){ this.$refs['wtiDuration'].focus() } }, 500)
        }
        this.loading.fetchData = false
    },
    methods: {
        // Enregistre / met à jour les lignes f_worktime AM et PM de la ligne groupée
        async saveWorktime(){
            this.saveProgress = true
            const eveId = this.item.wti_eve_id || this.eve_id
            try {
                for( const period of ['AM', 'PM'] ){
                    const duration = (period === 'PM') ? this.item.wti_duration_pm : this.item.wti_duration_am
                    const rowId    = (period === 'PM') ? this.item.wti_id_pm       : this.item.wti_id_am
                    if( !duration || duration === '00:00' ){
                        continue
                    }
                    const row = {
                        wti_eve_id    : eveId,
                        wti_usr_id    : this.item.wti_usr_id,
                        wti_equ_id    : this.item.wti_equ_id,
                        wti_typ_id    : this.item.wti_typ_id,
                        wti_date_start: this.item.wti_date_start,
                        wti_duration  : duration,
                        wti_period    : period
                    }
                    if( rowId > 0 ){
                        await this.$http.put( '/worktimes/' + rowId, row )
                    } else {
                        await this.$http.post( '/worktimes/', row )
                    }
                }
                // La durée de l'événement est recalculée par WorktimeList.switchModal(refresh)
                this.switchModal('modalWorktime', 0, 1)
            } finally {
                this.saveProgress = false
            }
        },
        deleteWorktime(){
            this.$root.$confirm('Supprimer', 'Confirmer la suppression de cette fiche', { color: 'red', width: 500 }).then((confirm) => {
                if( confirm ){
                    // Supprime les 2 lignes f_worktime (AM + PM) de la ligne groupée
                    const rowIds = [this.item.wti_id_am, this.item.wti_id_pm].filter( (id) => id > 0 )
                    Promise.all( rowIds.map( (id) => this.$http.delete( '/worktimes/' + id ) ) ).then( () => {
                        this.$root.$toast({ color: 'success', top:false, bottom:true, right:false, left:true, text:'Fiche supprimée !' })
                        this.switchModal('modalWorktime', 0, 1)
                    })
                }
            })
        }
    }
}
</script>